import jQuery from 'jquery';
let $ = jQuery;

// http://kenwheeler.github.io/slick/
import 'slick-carousel';

import Events from 'HSNDIR/Events.js';

/**
* class HSN.Carousel
*
* Turns an (un)ordered list of items into a carousel that slides it's children in and out of view while providing next, previous, and page buttons.
**/
HSN.Carousel = function (config) {
    /**
    * new HSN.Carousel(config)
    * - config (Object): A configuration object for the [[HSN.Carousel]]
    *   consisting of the following keys:
    *   - carousel (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an ordered or unordered list element that is the container of the items in the carousel.
    *   - showPager (Boolean): (!No longer used) A boolean indicating whether or not to show paging dots.
    *   - touch (boolean): Indicates whether the carousel should support touch events.
    *   - featuredCell (jQuery): (!No longer used) Selector of featured cell placed before carousel.
    **/

    let $carousel = $(config.carousel);

    if (!$carousel.data('hsn-carousel')) {
        $carousel.data('hsn-carousel', true);
        this.$carousel = $carousel;

        let $parent = $carousel.parent();
        $parent.css('overflow-x', 'hidden');

        $carousel.addClass('clearfix');
        $carousel.wrap('<div class="carousel"></div>');
        $carousel.css({
            'position': 'relative',
            'margin-left': '0px',
            'list-style-type': 'none',
            'padding-left': 0,
            'clear': 'both'
        });

        let zindex = $carousel.css('z-index');
        if (zindex === 'auto') {
            zindex = 0;
            $carousel.css('z-index', zindex);
        }
        zindex++;
        
        let slidesToShow = Math.floor($parent.innerWidth() / $carousel.find('li:first-child').outerWidth(true));
        slidesToShow = config.slidesToShow || slidesToShow || 1;

        this._currentSpeed = this._getScrollSpeedValue(config.autoScrollSpeed);
        this._firstTransitionTime = config.firstTransitionTime || 750;

        let swipeToSlide = config.swipeToSlide !== undefined ? config.swipeToSlide : Modernizr.touchevents;
        if (config.hintMoreSlides === true) {
            swipeToSlide = false;
        }
        
        let slick_options = {
            infinite: config.infinite === true || config.autoScrollOnHover === true,
            swipeToSlide: swipeToSlide,

            variableWidth: config.variableWidth === true,
            slidesToShow: slidesToShow + (config.hintMoreSlides ? config.hintAmount ? config.hintAmount : .5 : 0),
            slidesToScroll: config.slidesToScroll || slidesToShow,

            waitForAnimate: false,

            autoplay: config.autoScroll === true || config.autoScrollOnHover === true,
            pauseOnHover: config.autoScrollOnHover !== true,
            autoplaySpeed: this._currentSpeed,
            fade: config.fade === true,
            speed: config.fade === true ? 600 : 300,
            centerMode: config.centerMode === true,
            accessibility: true,
            focusOnChange: true,
            focusOnSelect: config.focusOnSelect,
            vertical: config.isVertical,
            verticalSwiping: config.verticalSwiping,
            dots: config.dots === true,
            customPaging: config.customPaging,
            appendDots: config.appendDots,
            responsive: config.responsive || null
        };

        if (!config.arrowsDisabled) {
            slick_options.prevArrow = config.prevButton || $('<button class="prev" type="button" aria-label="previous products">').insertBefore($carousel);
            slick_options.nextArrow = config.nextButton || $('<button class="next" type="button" aria-label="next set of products">').insertAfter($carousel);

            $(slick_options.prevArrow).css('z-index', zindex).on('click', function () {
                if (config.navigationCoremetricsTag) {
                    cmCreateManualLinkClickTag('/previous?cm_sp=' + config.navigationCoremetricsTag + '&cm_re=' + config.navigationCoremetricsTag + '\'');
                }
            });
            $(slick_options.nextArrow).css('z-index', zindex).on('click', function () {
                if (config.navigationCoremetricsTag) {
                    cmCreateManualLinkClickTag('/next?cm_sp=' + config.navigationCoremetricsTag + '&cm_re=' + config.navigationCoremetricsTag + '\'');
                }
            });
        }
        else {
            slick_options.arrows = false;
        }

        $('.slick-slide').focus(function () {
            $('.slick-active').find('a').attr({
                'tabindex': '-1'
            });
            $('.slick-active').find('input').attr({
                'tabindex': '-1'
            });
        });

        let application = HSN.Instance();
        let eventCoordinator = application.Events;
        $carousel.on('init afterChange', (event, slick) => {
            if (event.target !== $carousel[0]) {
                return; // nested carousels firing events
            }

            let currentSlide = slick.currentSlide;
            this.currentPage = currentSlide;
            eventCoordinator.Trigger(Events.Carousel.PAGE_CHANGED, currentSlide);

            if (!config.arrowsDisabled) {
                $(slick_options.prevArrow)
                    .toggle(slick_options.infinite || currentSlide > 0);
                $(slick_options.nextArrow)
                    .toggle(slick_options.infinite || currentSlide < slick.slideCount - slick_options.slidesToShow);
            }
        });
        
        $carousel.slick(slick_options);

        if (config.autoScrollOnHover) {
            setTimeout(() => {
                if ($carousel.is(':hover')) {
                    this.toggleAutoScroll(true, { firstTransitionTime: this._firstTransitionTime });
                }
            }, 0);
            $carousel.on('mouseenter', () => this.toggleAutoScroll(true, { firstTransitionTime: this._firstTransitionTime }));
            $carousel.on('mouseleave', () => this.toggleAutoScroll(false, { goToZero: true }));
        }
    }
};

/**
* HSN.Carousel.EVENT = Object
*
* An enumeration of events an [[HSN.Carousel]] can raise:
* - BEFORE_SLIDE: Right before the carousel slides: used to distinquish if slide is ensemble so other ele unrelated can be manipulated loosely
*
**/
HSN.Carousel.EVENT = Events.Carousel;

HSN.Carousel.prototype =
    {
        _currentSpeed: null,

        // TODO: REMOVE once fixed. -- prod script customcarousel.js is trying use these properties.
        nextButton: $(), // to attach a click event handler to next and prevButton.
        prevButton: $(), // Click handler turns off autoscroll when focused, which is already the slick-carousel default
        currentPage: 0, // After resize, resetting the page
        carouselContainer: $(), // Used to calculate # of slides to show.  Already done in the constructor.
        setCarouselWidth: () => { }, // sets the width
        setSizes: () => { }, // sets the slide sizes
        setPagerItems: () => { }, // TODO: expose pager options
        // End TODO:

        scrollToPage: function (page) {
            // negative indexing
            if (page < 0) {
                page = this.$carousel.find('li').length + page;
            }
            this.$carousel.slick('slickGoTo', page);
        },
        // serves as an enum.
        speedSettings: {
            SLOW: 1,
            MEDIUM: 2,
            FAST: 3,
            SUPERFAST: 4,
            properties: {
                1: { value: 10000 },
                2: { value: 5000 },
                3: { value: 3000 },
                4: { value: 1500 }
            }
        },
        toggleAutoScroll: function (toggle, options) {
            if (!toggle && options && options.goToZero) {
                this.scrollToPage(0);
            }

            // Different speed for the first transition so users don't wait too long.
            if (toggle && options && options.firstTransitionTime) {
                this._setOptions({ 'autoplaySpeed': options.firstTransitionTime });
                this.$carousel.one('afterChange', (event) => {
                    this._setOptions({ 'autoplaySpeed': this._currentSpeed });
                });
            }

            this.$carousel.slick(toggle ? 'slickPlay' : 'slickPause');
        },
        setAutoScrollSpeed: function (speed) {
            this._currentSpeed = this._getScrollSpeedValue(speed);

            this._setOptions({
                'autoplaySpeed': this._currentSpeed,
            });
        },
        enableTouch: function (enabled) {

        },

        // Private Helpers
        _getOption(name) {
            return this.$carousel.slick('slickGetOption', name);
        },
        _setOptions(values, refresh) {
            this.$carousel.slick('slickSetOption', values, refresh);
        },
        _getScrollSpeedValue(speedSetting) {
            let speed = this.speedSettings.properties[speedSetting || this.speedSettings.MEDIUM].value;
            return speed || this.speedSettings.properties[this.speedSettings.MEDIUM].value;
        }
    };



// WEBPACK FOOTER //
// ./assets/js/HSN/Carousel.js